<template>
  <div>
    <voxy-dropdown
      :class="['language-manager-teacher-filter', isActive && 'language-manager-teacher-filter_active']"
      ref="dropdown"
      menu-alignment="right"
      @on-open="isOpen = true"
      @on-close="isOpen = false"
    >
      <span slot="button" class="language-manager-teacher-filter__icon">
        <font-awesome-icon :icon="['fas', 'comments']" />
      </span>
      <div class="language-manager-teacher-filter__dropdown">
        <div class="language-manager-teacher-filter">
          <ul class="language-manager-teacher-filter__options">
            <li class="language-manager-teacher-filter__option">
              <voxy-radio
                class="language-manager-teacher-filter__radio"
                name="language_id"
                v-model="model"
                :value="null"
                >All</voxy-radio
              >
            </li>
            <li class="language-manager-teacher-filter__option" v-for="(option, index) in courseLanguages" :key="index">
              <voxy-radio
                class="language-manager-teacher-filter__radio"
                name="language_id"
                v-model="model"
                :value="option.language_id"
                >{{ option.english_name }}</voxy-radio
              >
            </li>
          </ul>
        </div>
      </div>
    </voxy-dropdown>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { VoxyDropdown, VoxyRadio } from '@voxy-team/vue-voxy';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'LanguagesTeacherManagerFilter',

  components: {
    FontAwesomeIcon,
    VoxyDropdown,
    VoxyRadio,
  },

  data() {
    return {
      isOpen: false,
      key: null,
    };
  },

  created() {
    this.fetchCourseLanguages();
  },

  computed: {
    ...mapGetters(['courseLanguages']),

    isApplied() {
      return this.key !== null;
    },

    isActive() {
      return this.isOpen || this.isApplied;
    },

    model: {
      get() {
        return this.key || null;
      },
      set(value) {
        this.key = value;
        this.applyFilter(value);
      },
    },
  },

  methods: {
    ...mapActions('manageTeachers', {
      applyFilter: 'SEARCH_BY_LANGUAGE',
    }),

    ...mapActions({
      fetchCourseLanguages: 'FETCH_COURSE_LANGUAGES',
    }),

    close() {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';

.language-manager-teacher-filter {
  &__icon {
    font-size: 21px;
    display: inline-flex;
    width: 1.5rem;
    justify-content: center;
    align-items: center;

    .language-manager-teacher-filter_active & {
      color: $default-blue;
    }
  }

  &__dropdown {
    min-width: 230px;
    padding: 15px 10px 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.25);
    background-color: #515151;
    border-radius: 5px;
  }

  &__options {
    max-height: 22rem;
    margin: 0;
    padding: 4px 12px;
    overflow-y: auto;
  }

  &__option {
    display: flex;
    line-height: 1.5em;
    align-items: center;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;

    &:not(:last-child) {
      margin-bottom: 13px;
    }

    input {
      font-size: 100%;
      width: 2em;
      height: auto;
      margin: 0 10px;
      padding: 0;
      color: white;
      text-align: center;
      border-bottom: 1px solid rgba(white, 0.5);
    }

    .voxy-radio__label {
      display: inline-flex;
      align-items: center;
      text-transform: none;
    }
  }

  &__radio {
    font-size: 13px;
    cursor: pointer;

    ::v-deep {
      .voxy-radio__label {
        font-weight: 500;
      }

      .voxy-radio__box {
        width: 12px;
        height: 12px;
        border-color: white;

        &::before {
          top: 2px;
          right: 2px;
          bottom: 2px;
          left: 2px;
        }
      }
    }
  }
}
</style>
